export enum CarRentalProviderEnum {
  PULPO = 'PULPO',
  CARBOOKR = 'CARBOOKR',
}
